// extracted by mini-css-extract-plugin
export default {"container":"Partners_container__cL-eE","row":"Partners_row__CnpRe","logo":"Partners_logo__gvUqT"};